import { ControllerInput, FlightController, PickContext, ScreenSpaceConversions } from "@novorender/api";

/**
 * Extends FlightController with a `rotationalInversion` flag that controls
 * whether left mouse button drag maps to camera rotation in the standard direction.
 *
 * When `rotationalInversion = true` (default): only the left-mouse-button axes
 * are negated before passing to the base controller — producing a "turntable /
 * look-around" feel matching the legacy models tool. Right mouse button orbit
 * and keyboard rotation are unaffected.
 *
 * Single-finger touch is left unsigned. The SDK FlightController already signs
 * touch opposite mouse, so negating `touch_1_move_*` here would cancel that
 * convention and invert mobile drag (BM-12542). Do not re-add those negations
 * for symmetry with the mouse axes.
 *
 * When `rotationalInversion = false`: camera behaves as standard.
 *
 * Roll is left to the base controller (horizon lock). SpaceMouse Object-mode past
 * vertical is handled by SpaceMouseFlightController while a session is live.
 */
export class InvertedFlightController extends FlightController {
    rotationalInversion: boolean = true;

    constructor(input: ControllerInput, pick: PickContext, conversions: ScreenSpaceConversions) {
        super(input, pick, conversions);
    }

    protected override getTransformations() {
        if (!this.rotationalInversion) {
            return super.getTransformations();
        }

        const axes = this.input.axes;
        axes.mouse_lmb_move_x = -axes.mouse_lmb_move_x;
        axes.mouse_lmb_move_y = -axes.mouse_lmb_move_y;

        return super.getTransformations();
    }
}
